import type { BetterAuthClientOptions } from "better-auth/client";
import { createAuthClient as createAuthClientImpl } from "better-auth/react";
import type { Auth } from "./types.js";
import { inferAdditionalFields, adminClient } from "better-auth/client/plugins";

export function createAuthClientReact(
  options: Omit<BetterAuthClientOptions, "plugins">,
) {
  return createAuthClientImpl({
    ...options,
    plugins: [inferAdditionalFields<Auth>(), adminClient()],
  });
}
